@use '@/styles/tokens' as *;

.avatar {
  flex-shrink: 0;
  background: $color-brand-200;
  color: $color-brand-800;
  font-weight: var(--font-weight-medium);
}

.withLabel {
  display: inline-flex;
  align-items: center;
}

.withLabel.lg {
  gap: 12px;
}

.withLabel.sm {
  gap: 6px;
}

.text {
  display: inline-flex;
  flex-direction: column;
  white-space: nowrap;
}

.lg .name {
  font-size: $font-size-md;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
}

.sm .name {
  font-size: $font-size-sm;
  color: var(--text-secondary);
}

.subtitle {
  font-size: $font-size-sm;
  color: var(--text-muted);
}
